module.exports = __webpack_public_path__ + "img/mammut-2x_163fa53428cbd8e520ba549bfdec709b.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/img/mammut-2x.jpg
// module id = 282
// module chunks = 0